import {
	CalendarTodayRounded,
	FormatAlignLeftOutlined,
	RemoveRedEye,
} from "@mui/icons-material";
import React, { useState, useCallback, useEffect } from "react";
import { EtatLabel } from "../../reunions/EtatLabel";
import { ALLOWED_CODE_ACTES } from "../actesDefinitions";
import styles from "./Agenda.module.scss";

export const Agenda = ({ actesLegislatifs = [], selectedActe }) => {
	const [pointsOdj, setPointsOdj] = useState([]);

	const filterPointsOdj = useCallback(() => {
		if (!selectedActe) return [];

		const codesReunions = ALLOWED_CODE_ACTES[selectedActe.codeActe]
			?.codesCurrentActe || [selectedActe.codeActe];
		return actesLegislatifs
			.filter((a) =>
				codesReunions.find((codeReunion) => a.codeActe.startsWith(codeReunion)),
			)
			.map((a) => a.pointOdj)
			.filter(Boolean)
			.toSorted((a, b) => {
				const dateA = new Date(a.agendaRef.timestampDebut);
				const dateB = new Date(b.agendaRef.timestampDebut);
				return dateA - dateB;
			});
	}, [actesLegislatifs, selectedActe]);

	useEffect(() => {
		setPointsOdj(filterPointsOdj());
	}, [filterPointsOdj]);

	const xsiTypeMapping = {
		podjReunion_type: "Réunion en commission",
		podjSeanceConfPres_type: "Séance publique",
	};

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.title}>Agenda et compte-rendus</div>
			</div>
			<div className={styles.content}>
				{pointsOdj?.length > 0 ? (
					<>
						{pointsOdj.map((pointOdj) => (
							// biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
							<div
								key={pointOdj.uid}
								className={styles.item}
								onClick={() =>
									window.open(
										`#/parliament/reunions/${pointOdj.agendaRef?.uid}`,
									)
								}
							>
								<div className={styles.itemInfo}>
									<div className={styles.itemHeader}>
										<div className={styles.place}>
											{xsiTypeMapping[pointOdj.xsiType] || pointOdj.xsiType}
										</div>
										<div className={styles.date}>
											<CalendarTodayRounded />
											{new Date(
												pointOdj.agendaRef?.timestampDebut,
											).toLocaleDateString("fr-FR", {
												year: "numeric",
												month: "long",
												day: "numeric",
												hour: "2-digit",
											})}
										</div>
										<div className={styles.title}> · </div>
										{pointOdj.etat && (
											<EtatLabel etat={pointOdj.etat} className={styles.etat} />
										)}
										<div className={styles.buttonsContainer}>
											{pointOdj.agendaRef?.compteRenduDisponible && (
												<div variant="outline" className={styles.button}>
													<FormatAlignLeftOutlined />
													<span>Lire le compte-rendu</span>
												</div>
											)}

											{pointOdj.videoUrl && (
												<a
													href={pointOdj.videoUrl}
													className={styles.buttonLink}
													aria-label="Voir la retranscription vidéo"
												>
													<button
														variant="outline"
														className={styles.button}
														aria-label="Voir la vidéo"
														type="button"
													>
														<RemoveRedEye />
														Vidéo
													</button>
												</a>
											)}
										</div>
									</div>
									<div className={styles.itemObjet}>{pointOdj.objet}</div>
								</div>
							</div>
						))}
					</>
				) : (
					<i className={styles.empty}>Pas de réunions</i>
				)}
			</div>
		</div>
	);
};
